exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1zx1qulK3A4ovb90GX7DKM{padding-inline-start:20px;padding-inline-end:20px}@media only screen and (min-width: 480px){._1zx1qulK3A4ovb90GX7DKM{padding-inline-start:36px;padding-inline-end:36px}}@media only screen and (min-width: 1280px){._1zx1qulK3A4ovb90GX7DKM{padding-inline-start:52px;padding-inline-end:52px}}._3FWoba7Uoc7bDaBS5h8Ngh{margin-inline-start:20px;margin-inline-end:20px}@media only screen and (min-width: 480px){._3FWoba7Uoc7bDaBS5h8Ngh{margin-inline-start:36px;margin-inline-end:36px}}@media only screen and (min-width: 1280px){._3FWoba7Uoc7bDaBS5h8Ngh{margin-inline-start:52px;margin-inline-end:52px}}._3fiqcXjEI2fEWroG2kfa6d{border:0;margin-inline-start:calc((50vw - (1600px / 2))*-1);width:calc(100vw - 8px)}", ""]);

// exports
exports.locals = {
	"navbarHeight": "72px",
	"grid-sides": "_1zx1qulK3A4ovb90GX7DKM",
	"gridSides": "_1zx1qulK3A4ovb90GX7DKM",
	"grid-sides-margins": "_3FWoba7Uoc7bDaBS5h8Ngh",
	"gridSidesMargins": "_3FWoba7Uoc7bDaBS5h8Ngh",
	"twitch-iframe": "_3fiqcXjEI2fEWroG2kfa6d",
	"twitchIframe": "_3fiqcXjEI2fEWroG2kfa6d"
};